<div class="app__router" #mainDiv>
  @if (showLoader) {
    <app-loader-fullscreen [blue]="true"></app-loader-fullscreen>
  } @else {
    <router-outlet></router-outlet>
  }
</div>
